import { render } from "./AddGuestsView.vue?vue&type=template&id=352cf724"
import script from "./AddGuestsView.vue?vue&type=script&lang=js"
export * from "./AddGuestsView.vue?vue&type=script&lang=js"

import "./AddGuestsView.vue?vue&type=style&index=0&id=352cf724&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__